import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fd_USA from "./translations/fd_USA";
import lc_USA from "./translations/lc_USA";
import en_CAN from "./translations/en_CAN";
import fr_CAN from "./translations/fr_CAN";
import TranslationsClient from "./clients/TranslationsClient";

const LANGUAGE_CODE_MAP = {
  en: "fd_USA",
  en_CA: "en_CAN",
  fr: "fr_CA",
};

export const mapLanguageCode = (lang) => {
  const mapped = LANGUAGE_CODE_MAP[lang] || lang;
  return `${TranslationsClient.getTranslationUrl()}${mapped}`;
};

let i18nToken = null;

export const setI18nToken = (token) => {
  i18nToken = token;
};

const isLikelyJwt = (token) => {
  if (!token) return false;
  const parts = token.split(".");
  return parts.length === 3 && parts[0].startsWith("eyJ");
};

export const createI18nBackendConfig = () => ({
  ns: ["emp"],
  defaultNS: "emp",
  fallbackLng: "en",
  supportedLngs: ["en", "lc_USA", "en_CA", "fr"],
  load: "languageOnly",
  partialBundledLanguages: true,
  debug: true,
  react: { useSuspense: false },
  backend: {
    loadPath: ([lang]) => mapLanguageCode(lang),
    customHeaders: () =>
      isLikelyJwt(i18nToken) ? { authorization: `Bearer ${i18nToken}` } : {},
    requestOptions: { cache: "no-cache" },
  },
});

let isI18nInitialized = false;

export const initI18n = async () => {
  if (isI18nInitialized) return;
  isI18nInitialized = true;

  try {
    await new Promise((resolve, reject) => {
      i18n.use(initReactI18next).init(
        {
          ns: ["emp"],
          defaultNS: "emp",
          fallbackLng: "en",
          supportedLngs: ["en", "lc_USA", "en_CA", "fr"],
          debug: true,
          react: {
            useSuspense: false,
          },
          resources: {
            en:     { emp: fd_USA },
            lc_USA: { emp: lc_USA },
            en_CA:  { emp: en_CAN },
            fr:     { emp: fr_CAN },
          },
        },
        (err) => {
          if (err) {
            reject(err);
            return;
          }
          resolve();
        }
      );
    });
  } catch (error) {
    console.error("Error initializing i18n:", error);
  }
};

export default i18n;
